import React from 'react';
import XSmall from '@uber/base-icons/x-small';
import { styled, useStyletron } from 'baseui';
import { LabelLarge } from 'baseui/typography';
import { useAtomValue } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import SideDrawer from '../../utils/side-drawer';
import { drawerAtom } from '../atoms';
const DrawerContainer = styled('section', ({
  $theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: $theme.sizing.scale800,
  padding: $theme.sizing.scale500,
  paddingBottom: 0,
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  boxSizing: 'border-box'
}));
const DrawerHeader = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: $theme.sizing.scale400
}));
const DrawerTitleSection = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: $theme.sizing.scale300
}));
export const ReviewDrawer = () => {
  const [_, theme] = useStyletron();
  const {
    isOpen,
    title,
    descriptionComponent,
    component
  } = useAtomValue(drawerAtom);
  const resetDrawer = useResetAtom(drawerAtom);
  return <SideDrawer isOpen={isOpen}>
      <DrawerContainer>
        <DrawerHeader>
          <DrawerTitleSection>
            <LabelLarge>{title}</LabelLarge>
            <XSmall height={theme.sizing.scale800} width={theme.sizing.scale800} onClick={resetDrawer} data-testid="close-drawer" />
          </DrawerTitleSection>
          {descriptionComponent()}
        </DrawerHeader>
        {component()}
      </DrawerContainer>
    </SideDrawer>;
};